<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">历史轨迹回放</div>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-vehicleview-root select-none">
          <MapView ref="trackMap" MapKey="DefaultMap" MapLayers=" "></MapView>
          <div class="map_control">
            <div>
              <div class="play_control_panel">
                <input type="hidden" id="selCar" />
                <div class="follow_btn">
                  <el-checkbox v-model="checked">画面跟随</el-checkbox>
                </div>
                <div class="playbutton" id="playbutton" @click="handlePlay($event)">
                  <div class="playbutton_icon" :class="{ isPauseing:isPauseing}"></div>
                </div>
                <div id="divspeed" @click="divspeed($event)" class="fl speedbtn">
                  <div class="speedbutton_icon"></div>
                  <span class="speedbutton_text" id="spanspeed">1X</span>
                </div>
                <div class="fl resetbutton" id="resetbutton" @click="handleReset">
                   <div class="resetbutton_icon"></div>
                  <span>重置</span>
                </div>
              </div>
              <div class="progress_bar">
                <el-slider v-model="progress" :show-tooltip="false"></el-slider>
              </div>
            </div>
          </div>
          <div class="map_search_panel">
            <div>
              <el-form>
                <el-form-item label="开始日期">
                  <el-date-picker placeholder="选择日期" v-model="BeginTime"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                  <el-date-picker placeholder="选择日期" v-model="EndTime"></el-date-picker>
                </el-form-item>
              </el-form>
              <el-button class="search_btn" @click="handleSearch">查 询</el-button>
              <div class="zj-layout-main-content bgcolor scrollable">
                <el-table
                  v-loading="loading"
                  :data="tableData"
                  ref="multipleTable"
                  border
                  style="width: 100%"
                  fixed
                  @row-click="handleRowClick"
                  highlight-current-row
                >
                  <el-table-column type="index" label="序号" width="50px"></el-table-column>
                  <el-table-column prop="carNo" label="车船ID" width="80px"></el-table-column>
                  <el-table-column prop="carName" label="车船名称"></el-table-column>
                  <el-table-column prop="plateNo" label="车牌号"></el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>
<script type="text/javascript" src="http://api.map.baidu.com/api?v=2.0&ak=E06eb9d756d0eafc722effb355657b4c"></script>  
<script>
import MapView from "./components/MapView";
import MyApis from "../../apis";
import { listCarShipTrack,carShipDrivingTrack } from "@/api/src/carship";

export default {
  name: "VehicleTrackViewNew",
  componentName: "VehicleTrackViewNew",
  components: {
    MapView,
  },
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {},
  data() {
    return {
      ImagePath: "lib/zjmap/Content/images/track",
      progress: 0,
      checked: false,
      tableData: [],
      CarId: "",
      BeginTime: new Date(),
      EndTime: new Date(),
      loading: false,
      isPauseing: false, //播放是否暂停
      timer: null,
      pointsAll: new Array(), //轨迹点位
      index: 0, ////记录播放到第几个point
      car: null, //汽车图标,
      polyline:null, //轨迹图
      listLine: new Object(),
      arrayObjLine: new Array(),
      label: null, //信息标签
      cartype: 1, //当前是车还是船，车为1，船为2
      carShipName: "", //车辆名称
      carPlateNo: "",//车牌号
      playSpeed: 1000, //毫秒
      playSpeedZoom: 1.0, //播放倍率
      speed:1
    };
  },
  methods: {
    handleSearch() {
      this.search();
    },
    handleRowClick(row) {
      this.CarId = row.carNo;
      this.$refs.multipleTable.setCurrentRow(row, true);
      this.handleLoadBtnClick(row.carType, row.carName, row.plateNo);
    },
    handleLoadBtnClick(type, carName, PlateNo) {
      this.cartype = type;
      this.carShipName = carName;
      this.carPlateNo = PlateNo;
      this.reset();
      this.pointsAll = new Array();
      let that = this;
      if (!this.CarId) {
        this.$message({
          message: "请先选择车船",
          type: "warning",
        });
        return;
      }
      let searchInfo = {
        carNo: this.CarId,
        startDate: this.BeginTime.format("yyyy-MM-dd 00:00:00"),
        endDate: this.EndTime.format("yyyy-MM-dd 23:59:59"),
        pageSize:2000,
        pageIndex:1,
      }
      carShipDrivingTrack(searchInfo).then((r) => {
          if (r.code != "200") {
            this.$message({
              message: "获取轨迹出错",
              type: "error",
            });
            return;
          }

          if (r.rows.length == 0) {
            this.$message({
              message: "无轨迹信息",
              type: "info",
            });
            return;
          }

          var data = [];

          $.each(r.rows.reverse(), function (index, item) {
            data.push({
              id: item.carNo,
              lng: item.longitude,
              mlng: item.longitude,
              lat: item.latitude,
              mlat: item.latitude,
              sp: item.speed,
              hx: item.angle,
              gt: item.dataTime,
            });
          });

          if (data != null && data.length > 0) {
            that.pointsAll = new Array();
            var mapInstance = that.$refs.trackMap.mapInstance;
            var map = mapInstance.map;
            map.centerAndZoom(new BMap.Point(data[0].mlng, data[0].mlat),13);
            for (var i = 0; i < data.length; i++) {
              var mappoint = new BMap.Point(data[i].mlng, data[i].mlat);
              that.pointsAll.push([
                mappoint,
                data[i].sp,
                that.setdirection(data[i].hx),
                data[i].gt,
                data[i].id,
                data[i].type,
              ]);
            }
            //超速
            let str = that.carPlateNo ? that.carPlateNo + " | " :''
            if (that.pointsAll[0][1] >= 30) {
              that.label = new BMap.Label(
                "<center><strong>" +
                  str +
                  that.pointsAll[0][1] +
                  "km/h" +
                  "</strong></center>" +
                  "时间: " +
                  that.pointsAll[0][3],
                {
                  position: that.pointsAll[0][0],
                  offset: new BMap.Size(-50, -50),
                }
              );
              that.label.setStyle({
                color: "#FFF",
                border: "#ABABAB 1px solid",
                background: "#ec3c3c",
              });
            } else {
              that.label = new BMap.Label(
                "<center><strong>" +
                 str +
                  that.pointsAll[0][1] +
                  "km/h" +
                  "</strong></center>" +
                  "时间: " +
                  that.pointsAll[0][3],
                {
                  position: that.pointsAll[0][0],
                  offset: new BMap.Size(-50, -50),
                }
              );
              that.label.setStyle({
                color: "#FFF",
                border: "#ABABAB 1px solid",
                background: "#329c12",
              });
            }
            if (that.cartype == "2") {
              that.car = new BMap.Marker(that.pointsAll[0][0], {
                icon: new BMap.Icon(
                  this.BASE_URL +
                    this.ImagePath +
                    "/boat/car4.png",
                  new BMap.Size(60, 60),
                  { imageOffset: new BMap.Size(0, 0) }
                ),
              });
            } else {
              that.car = new BMap.Marker(that.pointsAll[0][0], {
                icon: new BMap.Icon(
                  this.BASE_URL +
                    this.ImagePath +
                    "/car/car4.png",
                  new BMap.Size(60, 60),
                  { imageOffset: new BMap.Size(0, 0) }
                ),
              });
            }
            that.car.setLabel(that.label);

            var mapInstance = that.$refs.trackMap.mapInstance;
            var map = mapInstance.map;
            map.addOverlay(that.car);

            this.$message({
              message: "载入轨迹成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "无轨迹信息",
              type: "info",
            });
          }
          let pois=[];
          var mapInstance = that.$refs.trackMap.mapInstance;
          var map = mapInstance.map;
          that.pointsAll.map(v => {   //points是对象（含经纬度）
            var pt = new BMap.Point(v[0].lng,v[0].lat)
            pois.push(pt)
          })
          if(pois.length!=0){
            that.polyline = new BMap.Polyline(pois, {
              enableEditing: false, // 是否启用线编辑，默认为false
              enableClicking: false, // 是否响应点击事件，默认为true
              strokeWeight: 8, // 折线的宽度，以像素为单位
              strokeOpacity: 1, // 折线的透明度，取值范围0 - 1
              strokeColor: '#4C7FED' // 折线颜色
            })
            map.addOverlay(that.polyline)
          }
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
            type: "error",
          });
        });
    },
    search() {
      let searchInfo = {
        startDate:
          this.BeginTime == null
            ? "0001-01-01T00:00:00"
            : this.BeginTime.format("yyyy-MM-dd"),
        endDate:
          this.EndTime == null
            ? "0001-01-01T00:00:00"
            : this.EndTime.format("yyyy-MM-dd"),
      };

      this.loading = true;
      listCarShipTrack(searchInfo).then(res => {
        this.loading = false;
        this.tableData = res.data;
      }).catch((e) => {
        this.loading = false;
        this.$message({
          message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          type: "error",
        });
      });
    },
    setdirection: function (d) {
      var direction = 0;
      if ((d >= 0) & (d < 22)) {
        direction = 0;
      } else if ((d >= 22) & (d < 45)) {
        direction = 1;
      } else if ((d >= 45) & (d < 67)) {
        direction = 2;
      } else if ((d >= 67) & (d < 90)) {
        direction = 3;
      } else if ((d >= 90) & (d < 112)) {
        direction = 4;
      } else if ((d >= 112) & (d < 135)) {
        direction = 5;
      } else if ((d >= 135) & (d < 157)) {
        direction = 6;
      } else if ((d >= 157) & (d < 180)) {
        direction = 7;
      } else if ((d >= 180) & (d < 202)) {
        direction = 8;
      } else if ((d >= 202) & (d < 225)) {
        direction = 9;
      } else if ((d >= 225) & (d < 249)) {
        direction = 10;
      } else if ((d >= 249) & (d < 272)) {
        direction = 11;
      } else if ((d >= 272) & (d < 300)) {
        direction = 12;
      } else if ((d >= 300) & (d < 322)) {
        direction = 13;
      } else if ((d >= 322) & (d < 345)) {
        direction = 14;
      } else if ((d >= 345) & (d < 367)) {
        direction = 15;
      } else if (d >= 367) {
        direction = 16;
      }
      return direction;
    },
    handlePlay: function () {
      var that = this;

      if (!that.pointsAll || that.pointsAll.length == 0) {
        this.$message({
          message: "未加载轨迹信息",
          type: "info",
        });
        return;
      }
      if(!that.isPauseing){
        that.isPauseing = true;
        that.play();
      }else{
        that.isPauseing = false;
        that.pause();
      }
    },
    play: function () {
      let that = this;
      var point = that.pointsAll[that.index];
      var mapInstance = that.$refs.trackMap.mapInstance;
      var map = mapInstance.map;

      if(that.index>1 || that.index==0){
        map.removeOverlay(that.car);
      }
      if (that.cartype == "2") {
        that.car = new BMap.Marker(point[0], {
          icon: new BMap.Icon(
            this.BASE_URL + this.ImagePath + "/boat/car4.png",
            new BMap.Size(60, 60),
            { imageOffset: new BMap.Size(0, 0) }
          ),
        });
      } else {
        that.car = new BMap.Marker(point[0], {
          icon: new BMap.Icon(
            this.BASE_URL + this.ImagePath + "/car/car4.png",
            new BMap.Size(60, 60),
            { imageOffset: new BMap.Size(0, 0) }
          ),
        });
      }
         let str = that.carPlateNo ? that.carPlateNo + " | " :''
      if (point[1] >= 30) {
        that.label = new BMap.Label(
          "<center><strong>" +
            str +
            point[1] +
            "km/h" +
            "</strong></center>" +
            "时间: " +
            point[3],
          { position: point[0], offset: new BMap.Size(-50, -50) }
        );
        that.label.setStyle({
          color: "#FFF",
          border: "#ABABAB 1px solid",
          background: "#ec3c3c",
        });
      } else {
        that.label = new BMap.Label(
          "<center><strong>" +
            str +
            point[1] +
            "km/h" +
            "</strong></center>" +
            "时间: " +
            point[3],
          { position: point[0], offset: new BMap.Size(-50, -50) }
        );
        that.label.setStyle({
          color: "#FFF",
          border: "#ABABAB 1px solid",
          background: "#329c12",
        });
      }
      that.car.setLabel(that.label);
      map.addOverlay(that.car);

      that.index++;
      if (that.checked) {
        map.centerAndZoom(new BMap.Point(point[0].lng,point[0].lat), 16);
        map.panTo(point[0]);
      }
      
      if (that.index < that.pointsAll.length) {
        that.timer = setTimeout(function () {
          that.progress = (that.index + 1 ) / that.pointsAll.length * 100;
          that.play();
        }, that.playSpeed * that.playSpeedZoom);
      } else {
        if (that.timer) {
          window.clearTimeout(that.timer);
        }
        that.index = 0;
        that.progress = 0;
        that.isPauseing=false;
        $("#playbutton").attr(
          "src",
          this.BASE_URL + this.ImagePath + "/playicon/play.png"
        );
      }
    },
    divspeed: function (e) {
      var that = this;
      if (!that.pointsAll || that.pointsAll.length == 0) {
        this.$message({
          message: "未加载轨迹信息",
          type: "success",
        });
        return;
      }

      that.playSpeedZoom = that.setSpeed(e.target); 
      if (that.isPauseing) {
        $("#playbutton").data("speed", 0);
        $("#playbutton").attr(
          "src",
          this.BASE_URL + this.ImagePath + "/playicon/pause.png"
        );
        //that.play();
      }
    },
    setSpeed: function(that){
      var that = this;
      this.speed=this.speed*2;
      switch (this.speed) {
        case 2:
          $(that).data("speed", 0.25);
          $("#spanspeed").html("2X");
          return 0.5;
        case 4:
          $(that).data("speed", 0.125);
          $("#spanspeed").html("4X");
          return 0.25;
        case 8:
          $(that).data("speed", 0.0625);
          $("#spanspeed").html("8X");
          return 0.125;
      }
    },
    pause: function () {
      let that = this;
      if (that.timer) {
        window.clearTimeout(that.timer);
      }
    },
    handleReset: function () {
      let that = this;
      that.isPauseing = false;
      that.reset();
      this.$refs.multipleTable.setCurrentRow(-1);
    },
    reset: function () {
      let that = this;
      if (that.pointsAll.length == 0) {
        return;
      }
      that.pointsAll=new Array();
      var mapInstance = that.$refs.trackMap.mapInstance;
      var map = mapInstance.map;
      map.centerAndZoom(new BMap.Point(114.894208, 33.756094),13);
      that.checked = false;
      that.clearCar();

      $("#playbutton").data("speed", 1);
      $("#playbutton").attr(
        "src",
        this.BASE_URL + this.ImagePath + "/playicon/play.png"
      );
      $("#spanspeed").html("1X");
      this.speed=1;
      that.playSpeed=1000;
      that.playSpeedZoom=1.0;

      if (that.timer) {
        window.clearTimeout(that.timer);
      }
      that.index = 0;
      map.clearOverlays();
      that.progress = 0;
    },
    clearCar: function () {
      let that = this;
      var mapInstance = that.$refs.trackMap.mapInstance;
      var map = mapInstance.map;
      //clearCar();
      map.removeOverlay(that.car);

      if (that.arrayObjLine != undefined && that.arrayObjLine.length > 0) {
        for (var i = 0; i < that.arrayObjLine.length; i++) {
          that.listLine[that.arrayObjLine[i]].hide;
          map.removeOverlay(that.listLine[that.arrayObjLine[i]]);
        }
        that.arrayObjLine = new Array();
      }
    },
  },
  created() {},
  mounted() {
    this.search();
    this.logInfo.ActionName = "车辆轨迹查看";
    this.logInfo.LogMessage = "车辆轨迹查看";
    this.logInfo.ModuleName = "车辆调度";
    this.logInfo.PageName = "车辆轨迹查看";
    this.addOperationLog();
  },
  beforeDestroy() {},
  destroyed() {},
  controller: "Home",
  action: "VehicleTrackNew",
};
</script>

<style scoped>
.zj-vehicleview-root {
  height: 100%;
  width: 100%;
  position: relative;
}
</style>
<style>
.el-table__body tr.current-row>td {
    color: #fff;
    background: rgba(16, 199, 245, 0.66)!important;
}
</style>